module.exports = __webpack_public_path__ + "media/images/heart_hand-c2dce22b86b86d746c436b3d96d2b42c8ab848ecdddb9085983801a96b7c4f32.svg";